// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useState } from 'react';
import {MenuItem} from 'ui'
import { useParams } from 'react-router-dom';
import DropdownHeader from './DropdownHeader'
import ConversationPickerModal from 'chat/ConversationPickerModal';

const ChatHeader = (props) => {
    const { projectID } = useParams();
    const [showExportModal, setShowExportModal] = useState(false);

    const hideExportModal = () => {
        setShowExportModal(false);
    }

    const showExportModalClicked = () => {
        setShowExportModal(true);
    }

    const projectId = projectID;

    const dropdownOptions = [
        <MenuItem eventKey="1" onClick={showExportModalClicked}>
            View All Chats
        </MenuItem>
    ]

    return (
        <div>
            <ConversationPickerModal
              show={showExportModal}
              projectId={projectId}
              onHide={hideExportModal}
            />
            <DropdownHeader
                projectId={projectId}
                hasEditPermission={props.hasEditPermission}
                onShowCollabModal={props.onShowCollabModal}
                showCollabModal={props.showCollabModal}
                dropdownOptions={dropdownOptions}
            >
                AI Chat | Beta
            </DropdownHeader>
        </div>
    )
}

export default ChatHeader;